import _ from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import EmptyStateCard from 'packages/kakapo-ui-kit/components/cards/EmptyStateCard';
import Button, { ButtonSize } from 'packages/kakapo-ui-kit/components/editors/Button';

import GoalTemplateRow from './GoalTemplateRow';
import { useHistory } from '@treams/treams-routes';

const TabBar = styled(Flex)`
	border-bottom: 1px solid ${(props) => props.theme.colors.lightBlue};
	align-items: center;
	justify-content: flex-end;
	height: 53px;
`;

const Tab = styled(Box)<{ selected?: boolean }>`
	margin-bottom: -1px;
	font-size: 14px;
	padding: 18px 0px;
	margin-right: 44px;
	cursor: pointer;

	color: ${(props) => (props.selected ? props.theme.colors.primary : props.theme.colors.slateBlue)};
	border-bottom: 1px solid
		${(props) => (props.selected ? props.theme.colors.primary : props.theme.colors.lightBlue)};

	${(props) =>
		!props.selected &&
		`
	&:hover {
		color: black;
		border-bottom: 1px solid ${props.theme.colors.slateBlue};
	}`}
`;

export default function GoalTemplates(props: { jobTitle: graphql.JobTitle }) {
	const { t } = useTranslation();
	const { localize } = useLocalize();
	const history = useHistory();
	
	const addTemplate = () => history.push('/settings/goals');

	const goalTemplates = _.sortBy(
		props.jobTitle.goalTemplates.edges.map(({ node }) => node),
		(template) => localize(template.title).text,
	);

	if (!props.jobTitle.goalTemplates.edges.length) {
		return (
			<>
				<Box mt={3}>
					<EmptyStateCard
						title={t('settings.jobGoalTemplates.empty.title')}
						button={{
							title: t('settings.jobGoalTemplates.addButton.title'),
							onClick: addTemplate,
						}}
					/>
				</Box>
			</>
		);
	}

	return (
		<>
			<TabBar>
				<Box flexGrow={0} flexShrink={0}>
					<Button size={ButtonSize.Small} onClick={addTemplate}>
						{t('settings.jobGoalTemplates.addButton.title')}
					</Button>
				</Box>
			</TabBar>
			{goalTemplates.map((template) => (
				<GoalTemplateRow
					key={template.id}
					goalTemplate={template as graphql.GoalTemplate}
					jobTitle={props.jobTitle}
				/>
			))}
		</>
	);
}
